module.exports = __webpack_public_path__ + "img/Isumalogo.15977e1f.svg";